!function (n, dep, f) { if (typeof module !== 'undefined') { module.exports = f } else { define(n, dep, f) }}(
  'app.env',
  [],
  function () {

    /**
     * @typedef AppEnv
     * @property {number} USER_IS_ACTIVE_DELAY_MS
     * @property {string} survey_name
     * @property {string} API_BASE_URL
     * @property {number} auto_save_seconds
     * @property {1|0} live_ngene
     * @property {number} async_timeout_seconds
     *
     * // TODO: update to latest state
     */

    var
      DEFAULT_USER_IS_ACTIVE_DELAY_MS = 2000,
      /**
       * @type AppEnv
       */
      ENV = {}

    if (typeof window !== 'undefined' && window.SE) {
      ENV = window.SE && window.SE.APPENV
    } else if (typeof SE !== 'undefined' && SE) {
      ENV = SE.APPENV
    }

    if (!isNaN(parseInt(ENV.auto_save_seconds)) && ENV.auto_save_seconds !== -1) {
      ENV.USER_IS_ACTIVE_DELAY_MS = parseInt(ENV.auto_save_seconds) * 1000
    } else {
      ENV.USER_IS_ACTIVE_DELAY_MS = DEFAULT_USER_IS_ACTIVE_DELAY_MS
    }

    if (!ENV.API_BASE_URL) {
      ENV.API_BASE_URL = '//' + window.location.host + '/bin/api.pl'
    }

    return ENV

  });
define("app.env", function(){});

